import { AnnulledPrescription, ValidatedPrescription } from '../types';

export const isPrescriptionAnnulled = (
   prescription: ValidatedPrescription | AnnulledPrescription
): prescription is AnnulledPrescription => {
   return prescription.annulled;
};
